exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icons {\n  display: inline-block;\n  margin-top: -0.3rem;\n  vertical-align: middle;\n  padding-right: 0.25rem;\n}\n.icons img {\n  padding-right: 0.125rem;\n}", ""]);

// exports
